<template>
    <v-form v-model="valid" class="booking-agreement-form mb-5">
        <v-checkbox v-model="termsOfUse" :rules="[v => !!v || $t('confirmation_is_required')]" hide-details>
            <template v-slot:label>
                <div class="confirmation-text" @click.stop v-html="termsOfUseHtml" />
            </template>
        </v-checkbox>
        <v-checkbox v-model="privacyPolicy" :rules="[v => !!v || $t('confirmation_is_required')]" hide-details>
            <template v-slot:label>
                <div class="confirmation-text" @click.stop v-html="privacyPolicyHtml" />
            </template>
        </v-checkbox>
        <due-to-confirm-date-checkbox
            v-if="selectedAddOns.length === 0"
            :start-date="startDate"
            :_due-to-confirm-date="dueToConfirmDate"
            :_due-to-confirm-date-active="dueToConfirmDateActive"
            @change-due-to-confirm-date="dueToConfirmDate = $event"
            @change-due-to-confirm-date-active="dueToConfirmDateActive = $event"
        />
        <additional-agreement-checkboxes :room-offers="roomOffers" />
    </v-form>
</template>

<script lang="ts">
    import {Component, Emit, Prop, VModel, Vue} from 'vue-facing-decorator'
    import DueToConfirmDateCheckbox from '@/components/booking/forms/fields/DueToConfirmDateCheckbox.vue'
    import AdditionalAgreementCheckboxes from '~src/components/booking/forms/AdditionalAgreementCheckboxes.vue'

    @Component({
        components: {AdditionalAgreementCheckboxes, DueToConfirmDateCheckbox},
    })
    export class BookingAgreementForm extends Vue {
        @VModel() valid
        @Prop() countryId
        @Prop({required: true}) startDate
        @Prop({required: true}) selectedAddOns
        @Prop() roomOffers
        @Prop() _dueToConfirmDate
        @Prop() _dueToConfirmDateActive

        privacyPolicy = false
        termsOfUse = false

        @Emit()
        changeDueToConfirmDate(val) {
            return val
        }

        @Emit()
        changeDueToConfirmDateActive(val) {
            return val
        }

        get termsOfUseHtml() {
            return this.$t('confirmation_terms_of_use').replace('%s', `-${this.countryId}` || '')
        }

        get privacyPolicyHtml() {
            return this.$t('confirmation_privacy_policy').replace('%s', `-${this.countryId}` || '')
        }

        get dueToConfirmDate() {
            return this._dueToConfirmDate
        }

        set dueToConfirmDate(val) {
            this.changeDueToConfirmDate(val)
        }

        get dueToConfirmDateActive() {
            return this._dueToConfirmDateActive
        }

        set dueToConfirmDateActive(val) {
            this.changeDueToConfirmDateActive(val)
        }
    }

    export default BookingAgreementForm
</script>

<style scoped lang="scss">
    :deep(.confirmation-text) {
        font-size: 0.875rem;
    }
</style>
